<script>
  const src = 'https://cdn.cloud.qlean.ru/master/logos/wolagf.png'
</script>

<img {src} height="25" alt="Логотип Wola и GrowFood" />
